import { render, staticRenderFns } from "./contact_header.vue?vue&type=template&id=0ab4e8ed&scoped=true&"
import script from "./contact_header.vue?vue&type=script&lang=js&"
export * from "./contact_header.vue?vue&type=script&lang=js&"
import style0 from "./contact_header.vue?vue&type=style&index=0&id=0ab4e8ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab4e8ed",
  null
  
)

export default component.exports